import { LegalDocumentVersion } from '@models/LegalDocument'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { LEGAL_DOCUMENTS_URL } from '@utils/urls'

const fetchLegalDocumentVersions = (
  legalDocumentSlug: string,
  params: TableParams
) =>
  SBAPI.FetchPaginated<LegalDocumentVersion[]>(
    `${LEGAL_DOCUMENTS_URL}/${legalDocumentSlug}/versions`,
    params
  )

const createLegalDocumentVersion = (
  legalDocumentSlug: string,
  legalDocumentVersion: LegalDocumentVersion
) =>
  SBAPI.Post(
    `${LEGAL_DOCUMENTS_URL}/${legalDocumentSlug}/versions`,
    legalDocumentVersion
  )

const updateLegalDocumentVersion = (
  legalDocumentSlug: string,
  legalDocumentVersion: Partial<LegalDocumentVersion>
) =>
  SBAPI.Put(
    `${LEGAL_DOCUMENTS_URL}/${legalDocumentSlug}/versions/${legalDocumentVersion.id}`,
    legalDocumentVersion
  )

const deleteLegalDocumentVersion = (
  legalDocumentSlug: string,
  legalDocumentVersion: LegalDocumentVersion
) =>
  SBAPI.Delete(
    `${LEGAL_DOCUMENTS_URL}/${legalDocumentSlug}/versions/${legalDocumentVersion.id}`
  )

export {
  createLegalDocumentVersion,
  deleteLegalDocumentVersion,
  fetchLegalDocumentVersions,
  updateLegalDocumentVersion,
}
